import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  padding: 24px;
  box-shadow: 0 4px 8px -2px rgba(${ColorPalette.RGB.Black}, 0.12);
  margin-bottom: 20px;
`;

export const MessageContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const Message = styled.span`
  font-size: 12px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: -0.5px;
  color: ${({ theme }) => theme.dashboard.messageColor};
`;
